import React from "react";
import { ImagePlus, Trash2 } from "lucide-react";

function AddObsequiosComponents({
    id,
    mode,
    titulo,
    setTitulo,
    descripcion,
    setDescripcion,
    imagen,
    handleQuitarImagen,
    fechaInicio,
    setFechaInicio,
    fechaFin,
    setFechaFin,
    montoMinimo,
    setMontoMinimo,
    stockTotal,
    setStockTotal,
    limitePorUsuario,
    setLimitePorUsuario,
    handleAgregarImagen,
    handleGuardar,
    handleUpdate,
    handleCancelar,
    tipoObsequio,
    setTipoObsequio,
    montoGiftcard,
    setMontoGiftcard
}) {


    const tipoObsequios = [
        { value: "fisico", label: "Físico" },
        { value: "giftcard", label: "Gift Card" },
    ];



    return (
        <div className="rounded-xl bg-white p-6 shadow-xl">
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
                <div>
                    {mode === "view" ? (
                        <div className="relative aspect-square w-full overflow-hidden rounded-2xl border border-gray-200 bg-[#f1f5f9]">
                            {imagen ? (
                                <img
                                    src={imagen}
                                    alt="imagen obsequio"
                                    className="h-full w-full object-cover"
                                />
                            ) : (
                                <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                                    <p className="text-base font-semibold text-gray-700">No hay imagen</p>
                                    <p className="mb-5 text-sm text-gray-500">Seleccione una imagen para el obsequio</p>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="relative aspect-square w-full overflow-hidden rounded-2xl border border-gray-200 bg-[#f1f5f9]">
                            {imagen ? (
                                <>
                                    <button
                                        type="button"
                                        onClick={handleQuitarImagen}
                                        className="absolute right-3 top-3 z-10 rounded-lg bg-black/45 p-2 text-white transition-colors hover:bg-black/60"
                                    >
                                        <Trash2 size={18} />
                                    </button>
                                    <img
                                        src={imagen}
                                        alt="imagen obsequio"
                                        className="h-full w-full object-cover"
                                    />
                                </>
                            ) : (
                                <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                                    <p className="text-base font-semibold text-gray-700">No hay imagen</p>
                                    <p className="mb-5 text-sm text-gray-500">Seleccione una imagen para el obsequio</p>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        id="file-input-obsequio"
                                        onChange={handleAgregarImagen}
                                    />
                                    <label htmlFor="file-input-obsequio" className="cursor-pointer">
                                        <span className="inline-flex items-center gap-2 rounded-lg bg-[#104063] px-5 py-2.5 font-medium text-white transition-colors hover:bg-[#0d3553]">
                                            <ImagePlus size={16} />
                                            Agregar imagen
                                        </span>
                                    </label>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <div>
                        <label className="mb-1.5 block text-sm font-semibold text-gray-700">Titulo</label>
                        <input
                            type="text"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            autoCapitalize="none"
                            autoCorrect="off"
                            disabled={mode === "view"}
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                        />
                    </div>

                    <div>
                        <label className="mb-1.5 block text-sm font-semibold text-gray-700">Descripcion</label>
                        <textarea
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            autoCapitalize="none"
                            autoCorrect="off"
                            rows={4}
                            disabled={mode === "view"}
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                        />
                    </div>

                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Fecha inicio</label>
                            <input
                                type="date"
                                value={fechaInicio}
                                onChange={(e) => setFechaInicio(e.target.value)}
                                disabled={mode === "view"}
                                className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Fecha fin</label>
                            <input
                                type="date"
                                value={fechaFin}
                                onChange={(e) => setFechaFin(e.target.value)}
                                disabled={mode === "view"}
                                className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Tipo de obsequio</label>
                            <select
                                value={tipoObsequio}
                                onChange={(e) => setTipoObsequio(e.target.value)}
                                disabled={mode === "view"}
                                className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            >
                                <option value="">Seleccione un tipo</option>
                                {tipoObsequios.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>
                                        {tipo.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {tipoObsequio === "giftcard" && (
                            <div>
                                <label className="mb-1.5 block text-sm font-semibold text-gray-700">Monto Gift Card</label>
                                <input
                                    type="text"
                                    value={montoGiftcard ? Number(montoGiftcard).toLocaleString('es-PY', { style: 'currency', currency: 'PYG' }) : ''}
                                    //permitir solo numeros
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Permitir solo números y eliminar cualquier otro carácter
                                        const numericValue = value.replace(/[^0-9]/g, '');
                                        setMontoGiftcard(numericValue);
                                    }}
                                    disabled={mode === "view"}
                                    className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                />
                            </div>
                        )}
                    </div>

                    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Monto minimo</label>
                            <input
                                type="text"
                                value={montoMinimo ? Number(montoMinimo).toLocaleString('es-PY', { style: 'currency', currency: 'PYG' }) : ''}
                                //permitir solo numeros
                                onChange={(e) => {
                                    const value = e.target.value;
                                    // Permitir solo números y eliminar cualquier otro carácter
                                    const numericValue = value.replace(/[^0-9]/g, '');
                                    setMontoMinimo(numericValue);
                                }}
                                disabled={mode === "view"}
                                className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Stock total</label>
                            <input
                                type="number"
                                value={stockTotal}
                                onChange={(e) => setStockTotal(e.target.value)}
                                disabled={mode === "view"}
                                className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            />
                        </div>

                        <div>
                            <label className="mb-1.5 block text-sm font-semibold text-gray-700">Limite por usuario</label>
                            <input
                                type="number"
                                value={limitePorUsuario}
                                onChange={(e) => setLimitePorUsuario(e.target.value)}
                                disabled={mode === "view"}
                                className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-4 border-t border-gray-200 pt-6">
                {mode !== "view" && (
                    <button
                        type="button"
                        onClick={id ? handleUpdate : handleGuardar}
                        className="rounded-lg bg-[#104063] px-6 py-2 font-medium text-white transition-colors hover:bg-[#0d3553]"
                    >
                        Guardar
                    </button>
                )}
                <button
                    type="button"
                    onClick={handleCancelar}
                    className="rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors hover:bg-gray-200"
                >
                    Cancelar
                </button>
            </div>
        </div>
    );
}

export default AddObsequiosComponents;